{
  "content": [
    {
      "id": "e13cedf3-57c9-4a1a-88a8-0d34c353bdc1",
      "listingId": "8e1583bc-fffa-4d5b-8d83-c5f126e9c9c8",
      "playerInstanceId": "8f50edcf-76d7-4c5b-bed2-24a03e814346",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 4000000.00,
        "annualSalary": 2000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-05T22:33:06.185382Z",
      "cutoffAt": "2026-10-06T22:00:00Z",
      "reservationExpiresAt": "2026-10-08T22:00:00Z",
      "status": "CANCELLED",
      "reservationId": "0e0968e2-6a17-4e43-8cf5-5736626f2033",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "160b7fcc-64b4-5008-9e3f-6f5e2263c412",
      "playerName": "Marc Casadó",
      "playerDataAvailable": true
    },
    {
      "id": "3e667f22-d58b-4365-b6da-36ec929fc7f6",
      "listingId": "f01fea89-7787-4f74-9f1b-7a7d7fd9eeb3",
      "playerInstanceId": "6774caaf-918c-47ec-9ecb-902434156733",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 5000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-05T13:50:44.669036Z",
      "cutoffAt": "2026-10-05T22:00:00Z",
      "reservationExpiresAt": "2026-10-07T22:00:00Z",
      "status": "WON",
      "reservationId": "ec6f6cdb-acd5-438a-a20e-70610b35bb2d",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "778c494b-2ec4-5c50-a3bd-ba248524e251",
      "playerName": "Randy Nteka",
      "playerDataAvailable": true
    },
    {
      "id": "ac396609-53ca-4c17-bec1-f83ab3807de8",
      "listingId": "f01fea89-7787-4f74-9f1b-7a7d7fd9eeb3",
      "playerInstanceId": "8ba9e687-82fb-44aa-96e4-62d7f9585219",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 6000000.00,
        "annualSalary": 1500000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-05T09:51:07.229579Z",
      "cutoffAt": "2026-10-05T22:00:00Z",
      "reservationExpiresAt": "2026-10-07T22:00:00Z",
      "status": "WON",
      "reservationId": "4b5e75da-0610-4768-b4d7-413df750eecb",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "e67969e8-992e-5624-8576-11b15435cf3d",
      "playerName": "Angeliño",
      "playerDataAvailable": true
    },
    {
      "id": "a37cde83-06d5-49af-9b97-8682331d5113",
      "listingId": "8e0af5ae-3c4b-4327-8a62-91d36dba1888",
      "playerInstanceId": "4db2bb7b-59e1-4d26-9966-863afd4398d7",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 5300000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-04T12:10:16.094460Z",
      "cutoffAt": "2026-10-04T22:00:00Z",
      "reservationExpiresAt": "2026-10-06T22:00:00Z",
      "status": "LOST",
      "rejectionReason": "ACCEPTED_OTHER_CLUB",
      "reservationId": "e75b9f59-fd45-4f59-8f41-4a9808a93b5f",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "3dad646d-af3b-5467-83df-d5619d15479b",
      "playerName": "Anthony Gordon",
      "playerDataAvailable": true
    },
    {
      "id": "2895822f-0bb7-4e1a-8d5d-013a6d6845ee",
      "listingId": "e6c78459-1533-4507-9963-1fe22cf9daae",
      "playerInstanceId": "0bb048c6-db92-4b6c-8ddd-7faacaa83d34",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 3000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-03T12:47:31.458933Z",
      "cutoffAt": "2026-10-03T22:00:00Z",
      "reservationExpiresAt": "2026-10-05T22:00:00Z",
      "status": "LOST",
      "rejectionReason": "ECONOMIC_OFFER_TOO_LOW",
      "reservationId": "f8f75163-48f5-45f1-b4ee-01232c38be19",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "e49e63d6-c8a6-5afa-a315-67e6570e3965",
      "playerName": "Dávid Hancko",
      "playerDataAvailable": true
    },
    {
      "id": "f7778fe6-ecf0-4dc3-9b34-8af3a304fc06",
      "listingId": "e6c78459-1533-4507-9963-1fe22cf9daae",
      "playerInstanceId": "1fc9b7be-484f-4196-8844-5c8f08f39328",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 1000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-03T08:22:01.326172Z",
      "cutoffAt": "2026-10-03T22:00:00Z",
      "reservationExpiresAt": "2026-10-05T22:00:00Z",
      "status": "LOST",
      "rejectionReason": "RELEASE_CLAUSE_TOO_HIGH",
      "reservationId": "1bfff5d0-f571-4097-9f3b-0007ed362477",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "8ebf036b-1455-571c-a7ea-192960799ba9",
      "playerName": "Wojciech Szczęsny",
      "playerDataAvailable": true
    },
    {
      "id": "e080cd56-5ead-4bfa-8817-486454df2c50",
      "listingId": "d97e51b9-7163-4cdf-b043-e626dbd83f2d",
      "playerInstanceId": "639f5c8e-c4fb-4052-9731-5d583579edef",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 6200000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-02T12:36:39.733813Z",
      "cutoffAt": "2026-10-02T22:00:00Z",
      "reservationExpiresAt": "2026-10-04T22:00:00Z",
      "status": "WON",
      "reservationId": "9d88f6b7-2fbb-4e9f-9097-55f53480589c",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "e86eb34b-e58c-502d-a4e2-26701e285152",
      "playerName": "Cucho Hernández",
      "playerDataAvailable": true
    },
    {
      "id": "f122c9d4-7587-4d68-b52c-4a592f1e5315",
      "listingId": "d97e51b9-7163-4cdf-b043-e626dbd83f2d",
      "playerInstanceId": "6e0caf0b-66e2-43b0-bfaf-fa8040149cd5",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 8000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-02T08:00:03.067176Z",
      "cutoffAt": "2026-10-02T22:00:00Z",
      "reservationExpiresAt": "2026-10-04T22:00:00Z",
      "status": "CANCELLED",
      "reservationId": "1d4a9283-9a2a-4e1e-9c47-382cb5556249",
      "version": 5,
      "failure": null,
      "playerDefinitionId": "8b2dfca6-55c3-555f-b697-edd8318b59a1",
      "playerName": "Andrés García",
      "playerDataAvailable": true
    },
    {
      "id": "b14e6f9d-fec7-4ff9-9827-7b4b6326d33a",
      "listingId": "d97e51b9-7163-4cdf-b043-e626dbd83f2d",
      "playerInstanceId": "6e0caf0b-66e2-43b0-bfaf-fa8040149cd5",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 5000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-02T07:49:32.700765Z",
      "cutoffAt": "2026-10-02T22:00:00Z",
      "reservationExpiresAt": "2026-10-04T22:00:00Z",
      "status": "CANCELLED",
      "reservationId": "931f5e7e-176c-497c-b3ee-7ed06661400e",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "8b2dfca6-55c3-555f-b697-edd8318b59a1",
      "playerName": "Andrés García",
      "playerDataAvailable": true
    },
    {
      "id": "2e2d0c22-790d-4b01-a8b7-06ce95b900f7",
      "listingId": "d97e51b9-7163-4cdf-b043-e626dbd83f2d",
      "playerInstanceId": "64ed8a15-80fa-4c90-b684-920d1f21bd6e",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 5000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-02T07:40:29.723108Z",
      "cutoffAt": "2026-10-02T22:00:00Z",
      "reservationExpiresAt": "2026-10-04T22:00:00Z",
      "status": "CANCELLED",
      "reservationId": "d43bbb6f-f970-442b-a30b-a517918b87bb",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "c8e570ac-ea97-5bc4-8f0c-3b23807551ef",
      "playerName": "Pol Lozano",
      "playerDataAvailable": true
    },
    {
      "id": "158dc08b-12c6-4fcc-86d1-a217e91d4c54",
      "listingId": "d97e51b9-7163-4cdf-b043-e626dbd83f2d",
      "playerInstanceId": "0cd56203-693a-4e8f-864e-8b2d5e28f501",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 9000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-02T07:13:21.232936Z",
      "cutoffAt": "2026-10-02T22:00:00Z",
      "reservationExpiresAt": "2026-10-04T22:00:00Z",
      "status": "CANCELLED",
      "reservationId": "7febae7b-7c53-4410-a52d-221236703b75",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "ce704358-01b1-561a-b576-2c753e1e586a",
      "playerName": "Pedri",
      "playerDataAvailable": true
    },
    {
      "id": "15ea989a-d0a5-43ec-aa55-7ae977dbf417",
      "listingId": "1e6902f1-3f21-46b4-8d44-18a844f0a552",
      "playerInstanceId": "511f18f0-f325-4443-9c94-473714947f4d",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 1000000.00,
        "annualSalary": 2000000.00,
        "releaseClause": 3000000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-01T15:43:04.558269Z",
      "cutoffAt": "2026-10-01T22:00:00Z",
      "reservationExpiresAt": "2026-10-03T22:00:00Z",
      "status": "LOST",
      "reservationId": "28e7567f-15db-4762-bdff-4a0e7f09ae89",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "4e343d66-b75b-56ca-bff3-e3d8b307414b",
      "playerName": "Alberto Moleiro",
      "playerDataAvailable": true
    },
    {
      "id": "94aba8aa-f51c-4041-8e4c-7de633c7de60",
      "listingId": "1e6902f1-3f21-46b4-8d44-18a844f0a552",
      "playerInstanceId": "3c0493bf-c27e-4d4f-982a-8dfd95b24e70",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 7000000.00,
        "annualSalary": 2000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-01T12:14:32.842930Z",
      "cutoffAt": "2026-10-01T22:00:00Z",
      "reservationExpiresAt": "2026-10-03T22:00:00Z",
      "status": "WON",
      "reservationId": "99d12d27-de27-4f70-bc4f-ed295bf37c15",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "ec2b5909-e3bb-5e70-a134-fb13104dffd6",
      "playerName": "Álex Baena",
      "playerDataAvailable": true
    },
    {
      "id": "2f307220-2710-4759-b3f0-c1ba6d22b9fb",
      "listingId": "1e6902f1-3f21-46b4-8d44-18a844f0a552",
      "playerInstanceId": "b53022fb-0e36-4ece-a65a-4329fc2310fe",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 2000000.00,
        "annualSalary": 100000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 3
      },
      "submittedAt": "2026-10-01T11:06:26.900063Z",
      "cutoffAt": "2026-10-01T22:00:00Z",
      "reservationExpiresAt": "2026-10-03T22:00:00Z",
      "status": "LOST",
      "reservationId": "376bcdf8-4496-469b-a324-5746daed5a62",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "6a7f6309-a1cc-532a-b72f-ceee2819198a",
      "playerName": "Jorge de Frutos",
      "playerDataAvailable": true
    },
    {
      "id": "964e4eaf-6c36-44b4-a754-b7538a7717f3",
      "listingId": "1e6902f1-3f21-46b4-8d44-18a844f0a552",
      "playerInstanceId": "5b92a2ce-d763-462d-8059-72ba2a618cf2",
      "buyerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "terms": {
        "transferAmount": 9000000.00,
        "annualSalary": 1000000.00,
        "releaseClause": 20000000.00,
        "termSeasons": 1
      },
      "submittedAt": "2026-10-01T11:04:18.718622Z",
      "cutoffAt": "2026-10-01T22:00:00Z",
      "reservationExpiresAt": "2026-10-03T22:00:00Z",
      "status": "LOST",
      "reservationId": "6e1283b1-c85a-4be5-adeb-e0f5261d12e2",
      "version": 3,
      "failure": null,
      "playerDefinitionId": "52485d33-3fec-5fb2-ad9d-726c6b3302d5",
      "playerName": "Thibaut Courtois",
      "playerDataAvailable": true
    }
  ],
  "page": 0,
  "size": 20,
  "totalElements": 15,
  "totalPages": 1
}
